import React from 'react';
import useWindowSize from 'react-use/lib/useWindowSize';
import {Typography} from '@material-ui/core';
import AppColors from '../colors/AppColors';
import {blueGrey} from '@material-ui/core/colors';

export default function FinancialFutureTicketView() {

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
                alignItems: 'center',
                margin: 50,
                flexWrap: 'wrap',
            }}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                <Typography
                    style={{
                        fontSize: 34,
                        color: 'black',
                        fontWeight: 500,
                        maxWidth: 400,
                    }}
                    dangerouslySetInnerHTML={{__html: `Your Ticket to the Future of Financial <strong style='color:${AppColors.ACCENT_COLOR}'>Freedom</strong>`}}/>
                <Typography
                    style={{
                        fontSize: 20,
                        fontWeight: 400,
                        color: blueGrey[700],
                        paddingTop: 20,
                        lineHeight: 1.4,
                        maxWidth: 400
                    }}
                    dangerouslySetInnerHTML={{__html: ` A globally trusted brand for all things <b style='color:#546E7A'>Crypto</b> <span style='color:#607D8B'>Earnings, Multiplication and <span style='color:#607D8B'>Freebies</span>.`}}/>
            </div>
            <img
                src={require('./../images/future_of_investment.png')}
                height={300}
                width={500}
                style={{
                    maxWidth: 500,
                }}/>
        </div>
    );
}